export const GoogleSignInButton = ({ label }) => {
  const startGoogleSignIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `${process.env.REACT_APP_EMERGENT_AUTH_URL}?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <button
      type="button"
      onClick={startGoogleSignIn}
      data-testid="google-signin-button"
      className="flex w-full items-center justify-center gap-3 rounded-xl border-2 border-[#d8d1c3] bg-white px-4 py-3 font-semibold text-[#1b241e] transition-colors hover:border-[#b8aa91] hover:bg-[#f8f5ef] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#d97706] focus-visible:ring-offset-2"
    >
      <span aria-hidden="true" className="font-head text-lg font-bold text-[#4285f4]">G</span>
      {label}
    </button>
  );
};